<template>
  <div class="item" v-if="item.fields">
    <form-row
      v-for="(field, fieldName) in schema"
      :key="fieldName"
      :rules="rules[`${item.id}__${fieldName}`]"
      :prop="`${item.id}__${fieldName}`"
      :field="{
        ...field,
        name: `${item.id}__${fieldName}`,
        visibility: disabled ? 'disabled' : '',
        placeholder: 'Не выбрано',
        visual_value: {
          id: getField(field?.id_name?.name).value,
          name: getField(fieldName).value
        },
        value: getField(fieldName).value,
        id_name: {
          ...field?.id_name,
          value: getField(field?.id_name?.name).value
        }
      }"
      :options="[
        {
          id: getField(field?.id_name?.name).value,
          name: getField(fieldName).value
        }
      ]"
      :form="parentForm"
      :model="getField(fieldName).value"
      :noRequiredStar="true"
      @set-value="
        (name, val) =>
          handleChange({
            [`${item.id}__${fieldName}`]: val
          })
      "
      @change-option="changeOption"
      class="language-item"
    ></form-row>
    <Button
      buttonColor="transparent"
      buttonText=""
      iconName="delete"
      hasLeftIcon
      iconColor="#CDD4DA"
      :disabled="disabled"
      class="delete-button"
      @click.prevent="() => handleChange()"
    />
  </div>
</template>
<script>
import FormRow from 'Elements/Form/FormRow';
import Button from 'Elements/Button/Button';
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    schema: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number
    },
    disabled: Boolean,
    parentForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rules: {}
    };
  },
  created() {
    if (!this.item.fields) return;

    this.item.fields.forEach(item => {
      if (!this.schema[item.name]) return;

      if (this.schema[item.name].required) {
        this.$set(this.rules, `${this.item.id}__${item.name}`, {
          required: true,
          message: 'Необходимо заполнить поле',
          trigger: ['blur', 'focus', 'change']
        });
      }
    });
  },
  methods: {
    handleChange(fields = {}) {
      this.$emit('set-value', this.item, this.index, fields);
    },
    changeOption(name, idField, opt) {
      if (idField && opt) {
        this.$emit('set-value', this.item, this.index, {
          [`${this.item.id}__${idField.name}`]: opt.id
        });
      }
    },
    getField(fieldName) {
      return this.item.fields.find(({ name }) => name === fieldName) || {};
    }
  },
  components: {
    FormRow,
    Button
  }
};
</script>
<style lang="scss" scoped>
.item {
  width: 100%;
  display: flex;
  align-items: center;

  .language-item {
    margin-right: 12px !important;
    width: calc(100% - 12px) !important;

    & ::v-deep .el-form-item__label {
      font-size: 14px !important;
      line-height: 24px !important;
    }

    & ::v-deep .el-form-item__content {
      line-height: 24px !important;
    }
  }

  & ::v-deep label {
    margin: 0;
  }

  & ::v-deep .el-form-item__error {
    display: none;
  }

  .delete-button {
    align-self: flex-end;
    height: 40px;
    position: relative;
    cursor: pointer;

    &:hover {
      background: none;

      & ::v-deep path {
        fill: $black-50 !important;
      }
    }

    &:disabled {
      background: $black-30;
      color: $black-40;
    }
  }
}
</style>
